import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { OneSupplier, Supplier } from "../-data/schema";
import { Loading } from "@/layouts/loading";
import { PurchaseInvoiceManySchema } from "@/routes/(pharma)/_layout/reports/purchase-invoice-list/-data/type";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/suppliers/$supplierId/")({
  component: Component,
  loader: async ({params}) => {
    const supplierInfo = await pharmacyClient.getSupplier({
      id: params.supplierId,
    })

    const purchaseInvoiceList = await pharmacyClient.listPurchaseInvoices({
      supplierId: params.supplierId,
      pageNumber: 1,
      pageSize: 1000,
    })

    const creditNotes = await pharmacyClient.listCreditNotes({
      supplierId: params.supplierId,
      page: 1,
      pageSize: 1000,
      includeFullyUsed: true
    })

    return {
      supplier: supplierInfo,
      purchaseInvoices: purchaseInvoiceList,
      creditNotes: creditNotes
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1
});